import type { FC } from 'react'

import { Check, X } from 'lucide-react'
import { cn } from '@/lib/utils'

interface YesNoProps {
    value: string | boolean
    highlight?: boolean
    className?: string
}

/**
 * Soft check or cross for comparison tables. Text values render as text.
 */
export const YesNo: FC<YesNoProps> = ({ value, highlight = false, className }) => {
    if (typeof value === 'string') {
        return (
            <span className={cn(highlight ? 'font-heading text-base font-extrabold tracking-[-0.03em] md:text-lg' : 'text-sm text-stone', className)}>
                {value}
            </span>
        )
    }

    return value ? (
        <span className={cn('inline-flex size-9 items-center justify-center rounded-full bg-ember/20 text-ink', className)}>
            <Check
                aria-hidden='true'
                className='size-4'
                strokeWidth={2.5}
            />
            <span className='sr-only'>Included</span>
        </span>
    ) : (
        <span className={cn('inline-flex size-9 items-center justify-center rounded-full bg-ink/[0.05] text-ink/40', className)}>
            <X
                aria-hidden='true'
                className='size-4'
            />
            <span className='sr-only'>Not included</span>
        </span>
    )
}
